import {OnInit, Input, ElementRef, Directive, HostListener, Renderer2, Output, EventEmitter, DoCheck, IterableDiffers} from '@angular/core';

@Directive({
    selector: '[reOrderableList]',
    exportAs: 'reOrderableList',
    standalone: false
})
export class ReOrderableListComponent implements OnInit, DoCheck {
  @Input() reOrderableList!: Array<any>; // List is required to be passed in for ngOnChanges() to work

  @Output() moveUp = new EventEmitter();
  @Output() moveDown = new EventEmitter();

  index: number;

  otherElements: Array<HTMLElement>;
  thisElement: HTMLElement
  currentlyDragging = false;
  dragOffset: number = 0;
  iterableDiffer;
  notDraggingClassName = null;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private iterableDiffers: IterableDiffers) {}

  ngOnInit() {
    this.iterableDiffer = this.iterableDiffers.find(this.reOrderableList).create();
    this.thisElement = this.elementRef.nativeElement;
    const randomNumber = Math.random().toString().split('.')[1];
    this.notDraggingClassName = `notDraging${randomNumber}`;
    const style = document.createElement('style');
    style.innerHTML = `.${this.notDraggingClassName} { transform: none !important; position: inherit !important; }`;
    document.head.appendChild(style)
    this.thisElement.classList.add(this.notDraggingClassName)
  }

  ngDoCheck() {
    if (this.iterableDiffer.diff(this.reOrderableList)) {
      if (this.currentlyDragging) {
        this.getElementsInOrder();
      }

      this.updateTop(this.dragOffset)
    }
  }

  getElementsInOrder() {
    if (!this.thisElement)
      this.thisElement = this.elementRef.nativeElement;

    const parentElement = this.renderer.parentNode(this.elementRef.nativeElement) as HTMLElement;
    this.otherElements = Array.from(parentElement.children).filter(child => child.hasAttribute("ngdraggable")) as HTMLElement[];
    if (this.index == undefined || this.otherElements[this.index] != this.thisElement) {
      this.index = this.otherElements?.indexOf(this.thisElement) ?? -1;
    }
  }

  updateTop(pixelOffset = 0) {
    this.thisElement.style.top = pixelOffset + "px"
  }

  @HostListener('started', ["$event"])
  onStartDrag(div: HTMLElement) {
    this.currentlyDragging = true;
    this.thisElement = div;
    this.thisElement.classList.remove(this.notDraggingClassName)
    this.getElementsInOrder();
  }

  @HostListener('movingOffset', ["$event"])
  onUpdateDrag(event) {
    const myDiv = this.thisElement;
    const myDivRect = this.thisElement.getBoundingClientRect();
    const amountMoved = event.y + (+(myDiv?.style?.top?.slice(0, myDiv?.style?.top?.length-2) ?? 0)); // removes "px" from style


    const compareAndSwap = (compDirection: "up" | "down") => {
      const modifier = compDirection == "up" ? -1 : 1;
      const otherDivRect = this.otherElements[this.index + modifier].getBoundingClientRect();

      let checkMove: boolean = false;
      if (compDirection == "up")
        checkMove = myDivRect.top < otherDivRect.top; // note: lower number = higher on page
      else
        checkMove = myDivRect.bottom > otherDivRect.bottom;

      if (checkMove) {

        this.dragOffset = -event.y;

        if (compDirection == "up")
          this.moveUp.emit();
        else
          this.moveDown.emit()

      }
    }

    //if (amountMoved < -myDivRect.height/2 && this.index > 0) { // Can move up
    if (amountMoved < 0 && this.index > 0) { // Can move up
      compareAndSwap("up")
    }

    //if (amountMoved > myDivRect.height/2 && this.index < this.otherElements.length - 1) { // Can move down
    if (amountMoved > 0 && this.index < this.otherElements.length - 1) { // Can move down
      compareAndSwap("down")
    }
  }

  @HostListener('stopped', ["$event"])
  onFinishDrag(div: HTMLElement) {
    this.currentlyDragging = false;
    this.dragOffset = 0;
    this.thisElement.classList.add(this.notDraggingClassName)
    this.updateTop(0);
  }
}
